function Loader() {
    return (
        <div className="loading-div">
            <div class="circle-container">
                <div class="animated-circle one"></div>
                <div class="animated-circle two"></div>
                <div class="animated-circle three"></div>
            </div>
        </div>
    )
}

export default Loader;